// Ref: The opening_hours section of https://developers.google.com/places/web-service/details

export function parseOpenHours(openSlots, t) {
  let now = new Date()
  now = {
    day: now.getDay(),
    time: Number(
      now.getHours() + '' + (now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()),
    ),
    open: now.getDay(),
  }
  let openSlot = openSlots.find((e) => {
    if (e.open.day === 6 && e.close.day === 0) e.close.day = 7
    return (
      (e.open.day === 0 && e.open.time === '0000' && !e.close) || // 全年無休
      (e.open.day === now.day &&
        now.day === e.close.day &&
        Number(e.open.time) <= now.time &&
        Number(e.close.time) > now.time) ||
      (e.open.day === now.day && now.day < e.close.day && Number(e.open.time) <= now.time) ||
      (e.open.day < now.day && now.day === e.close.day && Number(e.close.time) > now.time) ||
      (now.day === 0 && e.open.day === 6 && e.close.day === 7 && Number(e.close.time) > now.time)
    )
  })
  let openHourText = ''
  let openDay = null
  if (openSlot) {
    const { open, close } = openSlot
    if (open.day == 0 && open.time == '0000' && !close) {
      openHourText = t('全年無休')
    } else if (open.time == '0000' && close.time == '0000') {
      openHourText = t('24 小時')
    } else {
      openHourText = convertDayToDisplayHour(openSlot)
      openDay = open.day
    }
  } else {
    const today = openSlots.find((d) => {
      return (
        (d.open.day === now.day && Number(d.open.time) > now.time) || // today not open
        (d.close.day === now.day && Number(d.close.time) < now.time)
      ) // today close
    })
    if (today) {
      openHourText = convertDayToDisplayHour(today)
    }
  }

  return {
    openDay,
    openNow: !!openSlot,
    openHourText,
  }
}

function convertDayToDisplayHour({ open, close }) {
  const openTime = open.time.slice(0, 2) + ':' + open.time.slice(2, 4)
  const closeTime = close.time.slice(0, 2) + ':' + close.time.slice(2, 4)
  return `${openTime}-${closeTime}`
}
